module.exports = {"id":"158969","name":"Leonardo Pisculichi","rating":"75","photo":"./data/images/photos/4/158969.png","club":{"name":"Argentinos Jrs.","logo":"./data/images/clubs/ArgentinosJrs..png"},"positions":["MOC","BU","MD"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/LeonardoPisculichi0.json
// module id = 2491
// module chunks = 0